import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'ชุดเช็กลิสต์ก่อนลงสนาม พร้อมใช้',
  description: 'รายการตรวจสอบที่ครบถ้วนก่อนเริ่มคลาสทุกครั้ง เพื่อให้การสอนราบรื่น 100%',
  value: '400฿'
}, {
  number: 2,
  title: 'แผนสำรองวันฝนตกและสนามเล็ก',
  description: 'ขั้นตอนที่ชัดเจนสำหรับวันที่สภาพอากาศหรือสถานที่ไม่เอื้ออำนวย ไม่มีความยุ่งเหยิงอีกต่อไป',
  value: '400฿'
}, {
  number: 3,
  title: 'คู่มือแบ่งกลุ่มเด็กแบบมืออาชีพ',
  description: 'วิธีจัดกลุ่มนักเรียนอย่างมีประสิทธิภาพตามระดับและทักษะ เพื่อผลลัพธ์ที่ดีที่สุด',
  value: '400฿'
}, {
  number: 4,
  title: 'แบบฟอร์มรายงานผู้ปกครอง พร้อมใช้',
  description: 'เทมเพลตพร้อมใช้สำหรับสื่อสารกับผู้ปกครองอย่างชัดเจนและมืออาชีพทุกเดือน',
  value: '400฿'
}, {
  number: 5,
  title: 'คลังเกมวอร์มอัพ 30 แบบ สำหรับทุกระดับ',
  description: 'คลังเกมวอร์มอัพ 30 แบบที่หลากหลาย สนุก และเหมาะสำหรับนักเรียนทุกระดับ',
  value: '400฿'
}, {
  number: 6,
  title: 'แผ่นสรุปโค้ช 1 หน้า ต่อคลาส',
  description: 'แผ่นสรุปรายคลาสแบบ 1 หน้าที่ช่วยให้คุณเตรียมการสอนได้ในเวลาไม่กี่นาที',
  value: '400฿'
}];
export function Bonuses() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-52">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-3 md:mb-4" data-id="element-53">
            6 โบนัสพิเศษที่รวมอยู่ด้วย
          </h2>
          <p className="text-xl md:text-2xl text-gold-accent font-bold" data-id="element-54">
            มูลค่ารวมของโบนัส: 2,400 ฿
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-55">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-lg border border-gold-accent/20 flex flex-col h-full relative overflow-hidden" data-id="element-56">
              <div className="flex flex-col sm:flex-row items-start gap-4 h-full" data-id="element-57">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gold-accent/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-58">
                  <Gift className="w-5 h-5 md:w-6 md:h-6 text-gold-accent" data-id="element-59" />
                </div>
                <div className="flex-1 flex flex-col h-full" data-id="element-60">
                  <div className="flex flex-wrap justify-between items-start gap-2 mb-2" data-id="element-61">
                    <h3 className="font-display font-bold text-navy-primary text-base md:text-lg pr-2" data-id="element-62">
                      โบนัส {bonus.number}: {bonus.title}
                    </h3>
                    <span className="bg-gold-accent text-navy-primary px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-63">
                      {bonus.value} ฟรี
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow" data-id="element-64">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}